// Single source of truth for the firm's address (display + machine forms).
export const ADDRESS_STREET = "515 Post Oak Blvd, Suite 700";
export const ADDRESS_CITY_STATE_ZIP = "Houston, Texas 77027";
export const ADDRESS = `${ADDRESS_STREET}, Houston, TX 77027`;
export const PHONE_NUMBER = "7136215000";
export const PRETTY_PHONE_NUMBER = "(713) 621-5000";
export const SD_PHONE_NUMBER = "+1-713-621-5000";
export const HREF_PHONE_NUMBER = `tel:${PHONE_NUMBER}`;
export const EMAIL = "info@orsakcpas.com";
export const HREF_EMAIL = `mailto:${EMAIL}`;
export const HOURS = "";

export * from "./hubspot";
export * from "./urls";
